import BaseRichContentPage from './BaseRichContentPage';
import {initTicketInformationBannerBlock} from '../helpers/ticketInformationBannerHelpers';

class EventPage extends BaseRichContentPage {
	constructor() {
		super();
		initTicketInformationBannerBlock();
		this.initMissingInfoModal();
	}

	loadContent() {
		import(
			/* webpackChunkName: "eventPageContent" */
			'../components/eventPageContent'
		)
		.then(({'default': EventPageContent}) => {
			new EventPageContent(window.eventPageParams);
		});
	}
	
	initMissingInfoModal() {
		if (document.getElementById('missingInfoModal')) {
			import(
				'../components/MissingInfoBlock'
			)
			.then(({'default': MissingInfoBlock}) => {
				new MissingInfoBlock({
					'pageType': `Club Page: ${window.eventPageParams.eventLocalizedName}`
				});
			});
		}
	}
}

new EventPage();